import './merchants.css';

import firebase from 'firebase';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { Redirect } from 'react-router';
import { Col, Container } from 'reactstrap';

class MerchantSignIn extends Component {
  uiConfig = null;
  ui = null;

  constructor(props, context) {
    super(props, context);

    this.uiConfig = {
      signInSuccessUrl: '/merchant/signup',
      signInOptions: [
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          defaultCountry: 'IE',
          recaptchaParameters: {
            size: 'invisible'
          }
        }
      ],
      // Terms of service url.
      tosUrl: 'https://www.bambooapp.ie/merchant-terms-conditions/'
    };

    this.state = {
      submitted: false
    };
  }

  componentDidMount() {
    document.title = "Merchant Log In - Bamboo";
  }

  render() {
    return (
      <Container className="merchants">
        {this.state.submitted ? <Redirect to="/success" /> : (this.context.authUser ? <Redirect to="/merchant/signup" /> : "")
        }
        <Col md={{ size: 6, offset: 3 }} className="mt-4">
          <StyledFirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth()} />
        </Col>
      </Container>
    );
  }
}

MerchantSignIn.contextTypes = {
  authUser: PropTypes.object,
  userId: PropTypes.string,
};

export default MerchantSignIn;
